<template>
  <div class="k-avatar">
    <img
      v-if="image"
      :src="image"
      alt="avatar"
      class="img"
    />
    <button
      v-if="changeImage"
      class="change"
      @click="$emit('change-image')"
    >
      <k-icon
        icon="photo-camera-add"
        class="icon"
      />
    </button>
  </div>
</template>

<script>
import KIcon from './KIcon.vue'

export default {
  name: "KAvatar",
  props: {
    image: {
      type: String,
      default: require('../assets/img/userPlaceholder.svg')
    },
    changeImage: Boolean
  },
  components: {
    KIcon
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/main.scss";

$k-avatar-mobile-size: 60px;
$k-avatar-desktop-size: 80px;

@mixin k-avatar($k-avatar-size) {
  width: $k-avatar-size;
  height: $k-avatar-size;
}

.k-avatar {
  position: relative;
  box-sizing: border-box;
  display: inline-flex;
  margin: 0;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  text-align: center;
  position: relative;
  background-color: rgba($neutral-1, 0.2);
  @include k-avatar($k-avatar-desktop-size);

  @include media-query(mobile) {
    @include k-avatar($k-avatar-mobile-size);
  }

  & > .img {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border-radius: 50%;
  }

  & > .change {
    border: none;
    position: absolute;
    right: 0;
    bottom: 0;
    cursor: pointer;
    margin: 0;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
    will-change: border, box-shadow;

    & > .k-icon {
      fill: $neutral-1;
      border: none;
    }

    &:focus {
      box-shadow: none;
      outline: none;
    }

    &:hover {
      border-color: $neutral-1;
      box-shadow: 0 0 0 2px $neutral-1;
    }
  }
}
</style>


// WEBPACK FOOTER //
// node_modules/kaledo-components/src/components/KAvatar.vue